// ES6-only built-ins, polyfilled using lodash. It is very hard to check and
// detect cases where we accidentally use one of these methods despite the lack
// of browser support, and it is simple enough to forward it to lodash.

// Please be extremely careful when editing this file. Third-party code may
// end up in here if they check for these methods and the browser did not
// provide them. If you add to this, match the ES6 spec as closely as possible.

const _ = require("lodash");

module.exports = function() {
	if (!Array.prototype.includes) {
		Array.prototype.includes = function(search, start) {
			return _.includes(this, search, start);
		};
	}
	if (!String.prototype.includes) {
		String.prototype.includes = function(search, start) {
			return _.includes(this, search, start);
		};
	}
	if (!String.prototype.startsWith) {
		String.prototype.startsWith = function(search, start) {
			return _.startsWith(this, search, start);
		};
	}
	if (!String.prototype.endsWith) {
		String.prototype.endsWith = function(search, start) {
			return _.endsWith(this, search, start);
		};
	}
	if (!String.prototype.repeat) {
		String.prototype.repeat = function(count) {
			return _.repeat(this, count);
		};
	}
	if (!Array.prototype.find) {
		Array.prototype.find = function(pred, thisArg) {
			if (typeof pred !== "function") {
				throw new TypeError(pred + " is not a function");
			}
			return _.find(this, pred.bind(thisArg || global));
		};
	}
	if (!Array.prototype.findIndex) {
		Array.prototype.findIndex = function(pred, thisArg) {
			if (typeof pred !== "function") {
				throw new TypeError(pred + " is not a function");
			}
			return _.findIndex(this, pred.bind(thisArg || global));
		};
	}
	if (!Array.prototype.fill) {
		Array.prototype.fill = function(value, start, end) {
			return _.fill(this, value, start, end);
		};
	}
};
